import { InMemoryCache } from "apollo-cache-inmemory"
import { ApolloClient } from "apollo-client"
import { from } from "apollo-link"
import { createHttpLink } from "apollo-link-http"
import { onError } from "apollo-link-error"
import process from "process"
import fetch from "node-fetch"

import { fragmentMatcher } from "../fragmentMatcher"

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.map(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(
          locations
        )}, Path: ${JSON.stringify(path)}`
      )
    )
  if (networkError) console.log(`[Network error]: ${networkError}`)
})

const getClient = (config) => {
  return new ApolloClient({
    connectToDevTools: !!process.browser,
    ssrMode: !process.browser,
    link: from([
      errorLink,
      createHttpLink({
        uri: process.browser ? "/graphql" : process.env.API_HOST,
        credentials: "same-origin",
        fetch: fetch,
        ...config,
      }),
    ]),
    cache: process.browser
      ? new InMemoryCache({ fragmentMatcher }).restore(window.__APOLLO_STATE__)
      : new InMemoryCache({ fragmentMatcher }),
  })
}

export default getClient
